import { render, staticRenderFns } from "./LabClientOrganisationsTable.vue?vue&type=template&id=9ccc7bc8"
import script from "./LabClientOrganisationsTable.vue?vue&type=script&lang=js"
export * from "./LabClientOrganisationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports